const CodeTypeOpts = [
  { label: "HO", value: "O" },
  { label: "Pool", value: "P" },
  { label: "Pangkalan", value: "H" },
];

export enum EntryType {
  DEBIT = "S",
  KREDIT = "H",
  DEBIT_KREDIT = "X",
}

export const CommonTrxTypes = [
  { label: "Debit", value: EntryType.DEBIT },
  { label: "Kredit", value: EntryType.KREDIT },
  { label: "Debit/kredit", value: EntryType.DEBIT_KREDIT },
];

export default CodeTypeOpts;
